<kendo-dialog *ngIf="testingDialogOpened" (close)="closeTestingForm()" [width]="1200">
  <kendo-dialog-titlebar>
    <h3>{{ 'RULE-TESTING' | translate }}</h3>
  </kendo-dialog-titlebar>
  <form novalidate [formGroup]="testingForm">
    <kendo-tabstrip #tabstrip>
      <kendo-tabstrip-tab title="{{ 'CONDITIONS' | translate }}" [selected]="true">
        <ng-template kendoTabContent>
          <app-query-builder class="col-md-12" [data]="query" [config]="config" [classNames]='classNames'>
          </app-query-builder>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'XML-INPUT' | translate }}">
        <ng-template kendoTabContent>
          <div class="form-group mt-2">
            <label class="control-label mr-2" for="active">{{ 'SAVE' | translate }}</label>
            <kendo-switch formControlName="xmlSave" onLabel="{{'YES' | translate }}" offLabel="{{'NO' | translate }}">
            </kendo-switch>
            <span [hidden]="!testingForm.controls.xmlSave.value"
              class="text-danger ml-2 text-uppercase font-weight-bold">{{ 'MUST-NOT-CONTAIN-PHI' | translate }}</span>
          </div>
          <div class="form-group">
            <textarea kendoTextArea class="w-100" style="font-family: monospace;" cols="120" rows="10"
              formControlName="xml">
            </textarea>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{'RULE-CHECK-RESULTS' | translate}}" [disabled]="!testingForm.controls.json.value">
        <ng-template kendoTabContent>
          <div class="form-group" style="max-height: 450px;">
            <ngx-json-viewer [json]="testingForm.controls.json.value"></ngx-json-viewer>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
  </form>
  <kendo-dialog-actions>
    <button appPreventClick class="k-button k-primary" [disabled]="!testingForm.valid"
      (click)="executeRuleTesting($event)">{{ 'EXECUTE-TEST' | translate }}</button>
    <button class="k-button" (click)="closeTestingForm()">{{ 'CLOSE' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>